module.exports = __webpack_public_path__ + "images/bonusred1.png";